import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { Flex } from 'reflexbox';

import { Button } from '../Button/index';
import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../Style/breakpoints';
import { ConnectedCourseCard } from '../CourseCard/connector';
import { ConnectedCourseCardProps } from '../CourseCard/types';
import {
  MIXIN_COURSE_CARD_GRID_TILE,
  MIXIN_COURSE_CARD_GRID,
} from '../../Style/mixins';

const Top = styled(Flex)({
  position: 'relative',
  flexDirection: 'row',
  padding: 12,
  justifyContent: 'space-between',
  alignItems: 'center',
});

const Heading = styled.h1`
  font-family: Avenir, sans-serif;
  font-style: normal;
  font-weight: 900;
  font-size: 22px;
  line-height: 120%;
  color: #041416;
  margin: 0;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    font-size: 30px;
  }
`;

const Container = styled(Flex)`
  justify-content: center;
  flex-direction: column;
  flex-grow: 1;

  margin: 0 auto;
  padding: 12px;
`;

const CourseCardContainer = styled('div')({
  ...MIXIN_COURSE_CARD_GRID,
  marginTop: 20,
  width: '100%',
});

const CourseCardTile = styled(ConnectedCourseCard)(MIXIN_COURSE_CARD_GRID_TILE);

const ButtonsContainer = styled(Flex)`
  display: none;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    display: flex;
  }
`;

export const FeaturedCourses = ({
  header,
  courses,
  showViewAll = true,
}: {
  header: string;
  courses: ConnectedCourseCardProps[];
  showViewAll?: boolean;
}): ReactElement => {
  return (
    <Container>
      <Top>
        <Heading>{header}</Heading>
        {showViewAll && (
          <ButtonsContainer>
            <Button
              variant="secondary"
              action={{
                kind: 'internal_link',
                value: {
                  link: {
                    to: {
                      type: 'ROUTE_COURSES',
                    },
                  },
                },
              }}
            >
              View all
            </Button>
          </ButtonsContainer>
        )}
      </Top>
      <CourseCardContainer>
        {courses.map((courseCardData) => {
          return (
            <CourseCardTile
              key={`coursecard-${courseCardData.path}`}
              {...courseCardData}
            />
          );
        })}
      </CourseCardContainer>
      {showViewAll && (
        <Flex justifyContent="center" m={24}>
          <Button
            variant="primary"
            action={{
              kind: 'internal_link',
              value: {
                link: {
                  to: {
                    type: 'ROUTE_COURSES',
                  },
                },
              },
            }}
          >
            View all courses
          </Button>
        </Flex>
      )}
    </Container>
  );
};
